<form fxLayout="column" name="poi-{{ poiId }}">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Titolo</mat-label>
      <input
        name="title"
        matInput
        [(ngModel)]="poi.title"
        type="text"
        required
      />
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline" style="width: 300px;">
      <mat-label>Posizione su Mappa</mat-label>
      <mat-icon matSuffix>place</mat-icon>
      <app-lat-lng-input
        [disabled]="disabled"
        [(value)]="poi.place"
        [searchText]="poi.title"
        required
      ></app-lat-lng-input>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="center start">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Descrizione</mat-label>
      <textarea
        style="height: 199px;"
        name="description"
        matInput
        [(ngModel)]="poi.description"
        required
      ></textarea>
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <app-itinerary-image-form-field
      [disabled]="disabled"
      [(image)]="poi.image"
      [label]="'Foto'"
    ></app-itinerary-image-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Link maggiori informazioni</mat-label>
      <input name="link" matInput [(ngModel)]="poi.link.longUrl" type="url" />
    </mat-form-field>
  </div>
</form>
